import { useContext } from "react";
import { ShowInfoModalContext } from "../../context/showInfoModal";

export default function ModalImag() {
  const { openModal, setOpenModal, info } = useContext(ShowInfoModalContext);

  const closeModal = () => {
    setOpenModal(false);
  };

  if (!openModal) return null;

  return (
    <div
      className="custom-modal-backdrop"
      onClick={closeModal}
    >
      <div
        className="custom-modal-content animate__animated animate__zoomIn"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="custom-modal-close"
          onClick={closeModal}
        >
          <i className="fa fa-times"></i>
        </button>

        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-lg-5 modal-image-container">
              <img src={info.img} alt={info.name} className="modal-image" />
            </div>
            <div className="col-lg-7 modal-details">
              <div className="modal-text-content">
                <h3 className="modal-member-name">{info.name}</h3>
                <div className="gold-divider"></div>
                <p className="modal-member-description">
                  {info.description}
                </p>
                <div className="modal-footer-decoration">
                  <span className="text-afrodita-gold">Afrodita Models</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}